import { Link } from 'react-router';
import { site } from '../../data/site.js';
import styles from './Brand.module.css';

/**
 * The mark has no background fill of its own, so it ships as two files
 * rather than one — black ink for the cream header, cream for the dark
 * footer. The alt is empty because the wordmark beside it already names
 * the company; announcing it twice is noise to a screen reader.
 */
export function Brand({ onDark = false }) {
  return (
    <Link to="/" className={`${styles.brand} ${onDark ? styles.onDark : ''}`.trim()}>
      <img
        src={onDark ? '/images/abode-mark-cream.png' : '/images/abode-mark-black.png'}
        alt=""
        width="48"
        height="15"
      />
      <span>{site.name}</span>
    </Link>
  );
}
